import { defineEffect } from '../../../core/effect';
import { posChangeEffectSpec } from '../fx/posChange';

/** 表示形式の変更（裏 ↔ 表）の **effect**: 変わったあとのパネル（motion の帯のあとに出る。組み立ては `../fx/posChange.js`） */
export default defineEffect({ situation: 'pos_change_flip', role: 'effect', ...posChangeEffectSpec('flip') }, 'pos_change_flip_effect.js');
